import React, { type FC } from 'react';
import type { TimeSlot } from '../../../../state/infiniteCalendarSeries';
import ConnectedTimeSlotSelector from '../TimeSlotSelector/ConnectedTimeSlotSelector';
import { getSessionsInfoText, mapSessionsToTimeSlotList } from '../utils';

type SimpleTimeSlotProps = {
    sessions: TimeSlot[];
    timezone: string;
    locale: string;
    isAppRebrandActive: boolean;
    onSessionClick: (sessionId: string, sessionLabel: string) => void;
    currency?: string;
};

const SimpleTimeSlotList: FC<SimpleTimeSlotProps> = ({
    timezone,
    sessions = [],
    locale,
    isAppRebrandActive,
    onSessionClick,
    currency,
}) => {
    const sessionsInfoText = getSessionsInfoText(sessions, locale, timezone);
    const sessionList = mapSessionsToTimeSlotList(
        sessions,
        isAppRebrandActive,
        currency,
    );

    return (
        <ConnectedTimeSlotSelector
            isAppRebrandActive={isAppRebrandActive}
            locale={locale}
            onSessionClick={onSessionClick}
            timezone={timezone}
            sessions={sessionList}
            sessionsInfoText={sessionsInfoText}
        />
    );
};

export default SimpleTimeSlotList;
